export default __webpack_public_path__ + "static/sleeptracker-e8a9ef813f45048c0a4d448bcdd57eba.png";